import { IntlShape } from 'react-intl';
import {
  ActiveAuthorizePaymentPage,
  EVENT_NAME,
  Tabs,
  VIRTUAL_CARD
} from 'common/constants';
import {
  TableHeaderFiltersType,
  TotalsFooterType
} from 'components/ComposedTable/types';
import { VendorsInvoicePairsType } from 'components/PrintViewer/PdfExport/types';
import { amplitudeTracker, ContextValue } from 'utils/AmplitudeTracker';
import { formatCurrency } from 'utils/formatCurrency';
import { IS_SELECTED, IS_NOT_SELECTED } from './constants';
import { exportMessages } from './messages';

export const getHeaderContent = (
  whichScreen: string,
  intl: IntlShape,
  tableHeaderFilters?: TableHeaderFiltersType,
  activeAuthorizePaymentPage?: string,
  interCompanyFlag?: boolean
): string => {
  const {
    store,
    documentTitle,
    dueOnOrBefore,
    paymentDate,
    paymentMethod,
    status,
    total,
    cibAccount,
    postingDescription,
    cashAccount,
    cashCompany,
    cashDisbursementsJournal
  } = exportMessages;

  if (
    whichScreen === Tabs.NeedsAuthorization &&
    (!activeAuthorizePaymentPage || activeAuthorizePaymentPage === '')
  )
    return `    ${intl.formatMessage(store)}: ${
      tableHeaderFilters?.selectedStore || ''
    }

    ${intl.formatMessage(documentTitle)}: ${String(
      tableHeaderFilters?.tableTitle
    )}

    ${intl.formatMessage(dueOnOrBefore)}: ${
      tableHeaderFilters?.selectedDueDate || ''
    }

    ${intl.formatMessage(paymentMethod)}: ${
      tableHeaderFilters?.selectedPaymentMethods || ''
    }`;

  if (whichScreen === Tabs.ReconcileCreditCards)
    return `    ${intl.formatMessage(store)}: ${
      tableHeaderFilters?.selectedStore || ''
    }

    ${intl.formatMessage(documentTitle)}: ${String(
      tableHeaderFilters?.tableTitle
    )}

    ${intl.formatMessage(status)}: ${tableHeaderFilters?.selectedStatus || ''}`;

  if (
    activeAuthorizePaymentPage === ActiveAuthorizePaymentPage.AuthorizeReview &&
    tableHeaderFilters?.selectedPaymentMethods === VIRTUAL_CARD &&
    whichScreen !== Tabs.ToBePaid &&
    !interCompanyFlag
  )
    return `    ${intl.formatMessage(total)}: ${formatCurrency(
      tableHeaderFilters?.total
    )}

    ${intl.formatMessage(cibAccount)}: ${String(
      tableHeaderFilters?.selectedCIBAccount
    )}

    ${intl.formatMessage(postingDescription)}: ${String(
      tableHeaderFilters?.postingDescription
    )}

    ${intl.formatMessage(documentTitle)}: ${String(
      tableHeaderFilters?.tableTitle
    )}

    ${intl.formatMessage(paymentDate)}: ${String(
      tableHeaderFilters?.paymentDate
    )}`;

  if (
    activeAuthorizePaymentPage === ActiveAuthorizePaymentPage.AuthorizeReview &&
    tableHeaderFilters?.selectedPaymentMethods === VIRTUAL_CARD &&
    whichScreen !== Tabs.ToBePaid &&
    !interCompanyFlag
  )
    return `    ${intl.formatMessage(total)}: ${formatCurrency(
      tableHeaderFilters?.total
    )}
    
        ${intl.formatMessage(cibAccount)}: ${String(
      tableHeaderFilters?.selectedCIBAccount
    )}
    
        ${intl.formatMessage(postingDescription)}: ${String(
      tableHeaderFilters?.postingDescription
    )}
    
        ${intl.formatMessage(documentTitle)}: ${String(
      tableHeaderFilters?.tableTitle
    )}
    
        ${intl.formatMessage(paymentDate)}: ${String(
      tableHeaderFilters?.paymentDate
    )}`;

  if (
    activeAuthorizePaymentPage === ActiveAuthorizePaymentPage.AuthorizeReview &&
    tableHeaderFilters?.selectedPaymentMethods === VIRTUAL_CARD &&
    whichScreen !== Tabs.ToBePaid &&
    interCompanyFlag
  )
    return `    
    
      ${intl.formatMessage(documentTitle)}: ${String(
      tableHeaderFilters?.tableTitle
    )} 
      ${intl.formatMessage(total)}: ${formatCurrency(tableHeaderFilters?.total)}
  
      ${intl.formatMessage(cashCompany)}: ${String(
      tableHeaderFilters?.cashCompany
    )}
      ${intl.formatMessage(cashAccount)}: ${String(
      tableHeaderFilters?.cashAccount
    )}
      ${intl.formatMessage(cashDisbursementsJournal)}: ${String(
      tableHeaderFilters?.cashDisbursementsJournal
    )}
      ${intl.formatMessage(postingDescription)}: ${String(
      tableHeaderFilters?.postingDescription
    )}
      ${intl.formatMessage(paymentDate)}: ${String(
      tableHeaderFilters?.paymentDate
    )}`;

  if (
    activeAuthorizePaymentPage === ActiveAuthorizePaymentPage.ReviewChecks &&
    interCompanyFlag
  ) {
    return `
    ${intl.formatMessage(documentTitle)}: ${String(
      tableHeaderFilters?.tableTitle
    )} 
    
    ${intl.formatMessage(total)}: ${formatCurrency(tableHeaderFilters?.total)}

    ${intl.formatMessage(cashCompany)}: ${String(
      tableHeaderFilters?.cashCompany
    )}
    ${intl.formatMessage(cashAccount)}: ${String(
      tableHeaderFilters?.cashAccount
    )}
    ${intl.formatMessage(cashDisbursementsJournal)}: ${String(
      tableHeaderFilters?.cashDisbursementsJournal
    )}
    ${intl.formatMessage(postingDescription)}: ${String(
      tableHeaderFilters?.postingDescription
    )}
    ${intl.formatMessage(paymentDate)}: ${String(
      tableHeaderFilters?.paymentDate
    )}
    `;
  }

  return activeAuthorizePaymentPage ===
    ActiveAuthorizePaymentPage.AuthorizeResult
    ? `     ${intl.formatMessage(documentTitle)}: ${String(
        tableHeaderFilters?.tableTitle
      )}`
    : `   ${intl.formatMessage(total)}: ${formatCurrency(
        tableHeaderFilters?.total
      )}

      ${intl.formatMessage(documentTitle)}: ${String(
        tableHeaderFilters?.tableTitle
      )}`;
};

export const getFooterContent = (
  whichScreen: string,
  intl: IntlShape,
  totalsInFooter?: TotalsFooterType
): string => {
  const {
    discount,
    totalOwed,
    selectedTotal,
    pending,
    settled,
    voided,
    reconciled,
    total
  } = exportMessages;
  if (whichScreen === Tabs.NeedsAuthorization)
    return `    ${intl.formatMessage(discount)}: ${formatCurrency(
      totalsInFooter?.discountTotalInFooter
    )}

    ${intl.formatMessage(totalOwed)}: ${formatCurrency(
      totalsInFooter?.totalOwedInFooter
    )}

    ${intl.formatMessage(selectedTotal)}: ${formatCurrency(
      totalsInFooter?.selectedTotalInFooter
    )}`;

  if (whichScreen === Tabs.ReconcileCreditCards)
    return `    ${intl.formatMessage(pending)}: ${formatCurrency(
      totalsInFooter?.totalPending
    )}

    ${intl.formatMessage(settled)}: ${formatCurrency(
      totalsInFooter?.totalSettled
    )}

    ${intl.formatMessage(voided)}: ${formatCurrency(
      totalsInFooter?.totalVoided
    )}

    ${intl.formatMessage(reconciled)}: ${formatCurrency(
      totalsInFooter?.totalReconciled
    )}

    ${intl.formatMessage(total)}: ${formatCurrency(
      totalsInFooter?.totalAmount
    )}`;
  return '';
};

export const isInvoiceSelected = (
  selectedVendorInvoicePairs: VendorsInvoicePairsType[],
  data: { vendorNo?: string; invoiceId?: string }
): string =>
  selectedVendorInvoicePairs.findIndex(
    pair =>
      pair.invoiceId === data?.invoiceId && pair.vendorNo === data?.vendorNo
  ) === -1
    ? IS_NOT_SELECTED
    : IS_SELECTED;

export const isVendorSelected = (
  selectedVendorInvoicePairs: VendorsInvoicePairsType[],
  key: string
): string =>
  selectedVendorInvoicePairs.findIndex(pair => pair.vendorNo === key) === -1
    ? IS_NOT_SELECTED
    : IS_SELECTED;

export const exportArchiveAmplitude = (
  selectionType: string,
  fileType: string,
  whichScreen: string,
  amplitude: ContextValue
): void => {
  if (whichScreen === Tabs.ReconcileCreditCards) {
    amplitudeTracker(amplitude, EVENT_NAME.ExportCreditCardPayments, {
      [selectionType]: [`.${fileType}`]
    });
  }
};
